import { css, html, LitElement } from "lit"
import { EVENEMENT_BOUTON_MODIFIER_POKEMON, EVENEMENT_BOUTON_SUPPRIMER_POKEMON } from "./Pokemon.js"

/**
 * @typedef {import('./types/types.js').Pokemon} Pokemon
 */

export const EVENEMENT_SUPPRIMER_POKEMON_AMI = "evenementSupprimerPokemonAmi",
  EVENEMENT_MODIFIER_POKEMON_AMI = "evenementModifierPokemonAmi"

export default class ListePokemons extends LitElement {
  static properties = { listePokemons: { type: Array }, ami: { type: String }, estModeAmis: { type: Boolean } }

  static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            background-color: var(--couleur-fond);
            border-radius: 1rem;
            gap: 1.5rem;
        }`

  constructor() {
    super()
    this.listePokemons = []
    this.ami = ""
    this.estModeAmis = true
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener(EVENEMENT_BOUTON_SUPPRIMER_POKEMON, (event) => this.supprimerPokemon(event))
    this.addEventListener(EVENEMENT_BOUTON_MODIFIER_POKEMON, (event) => this.modifierPokemon(event))
  }

  render() {
    return html`${this.listePokemons.map(({ nom = "", id, specificites = {}, commentaire = "" }) => html`<p-pokemon nom="${nom}" .id=${id} .specificites=${specificites} .commentaire=${commentaire} .estModeAmis=${this.estModeAmis}></p-pokemon>`)}`
  }

  /**
   * @param {CustomEvent} event
   */
  supprimerPokemon(event) {
    event.stopPropagation()
    this.dispatchEvent(
      new CustomEvent(EVENEMENT_SUPPRIMER_POKEMON_AMI, {
        bubbles: false,
        composed: true,
        detail: { idAmi: this.ami, id: event.detail.id },
      }),
    )
  }

  /**
   * @param {CustomEvent} event
   */
  modifierPokemon(event) {
    event.stopPropagation()
    this.dispatchEvent(
      new CustomEvent(EVENEMENT_MODIFIER_POKEMON_AMI, {
        bubbles: false,
        composed: true,
        detail: {
          idAmi: this.ami,
          pokemon: {
            nom: event.detail.nom,
            id: event.detail.id,
            specificites: event.detail.specificites,
            commentaire: event.detail.commentaire,
          },
        },
      }),
    )
  }
}

customElements.define("p-liste-pokemons", ListePokemons)
